import { render, staticRenderFns } from "./PagamentoObservacoes.vue?vue&type=template&id=49f4b208&"
import script from "./PagamentoObservacoes.vue?vue&type=script&lang=js&"
export * from "./PagamentoObservacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports